export const userTabletype={
    '1': '内部用户',
    '2': '外部用户'
}

export const userTablemode={
    '1': '启用',
    '2': '停用'
}

export const userTabletemplate={
    'routersoft-rmt': '路特融媒体渠道',
    'routersoft-qms': '路特全媒体渠道',
    'routersoft-mcp': '路特融媒体渠道',
    'eastnet-mc': '东方网融媒体平台'
}